import React from 'react';
import SeoHead from '../../components/common/SeoHead';
import SolarInstallationCalculator from '../../components/calculators/SolarInstallationCalculator';

const seoData = {
  title: 'Solar Panel Installation Cost Calculator',
  description: 'Estimate your solar panel installation costs in South Africa. Get a free, instant quote for your project.',
  keywords: 'solar installation calculator, solar panel cost, installation quote, South Africa, solar calculator',
  path: '/calculators/installation',
  image: '/images/solar-installation-og.jpg'
};

const SolarInstallationCalculatorPage = () => {
  return (
    <div className="page-container w-full flex items-center justify-center p-2 sm:p-4">
      <SeoHead template="calculator" data={seoData} />
      <div className="card-section w-full max-w-2xl rounded-lg shadow-lg p-4 sm:p-8">
        <SolarInstallationCalculator />
      </div>
    </div>
  );
};

export default SolarInstallationCalculatorPage; 